import React, { useEffect, useState } from "react";
import "../../assets/css/dashboard.css";
import timeIcon from "../../assets/img/time.webp";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
} from "recharts";
import APIServices from "../../services/APIServices";
import Loader from "../../components/Loader";

const Dashboard = () => {
  const [dasboardData, setDasboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTabUsers, setActiveTabUsers] = useState("1day");
  const [activeTabProjects, setActiveTabProjects] = useState("1day");

  const fetchDashboardMetrics = async () => {
    setLoading(true);
    try {
      const response = await APIServices.post(`/admin/dashboard-metrics`);
      if (response.totalCompanies) {
        console.log(response);
        setDasboardData(response);
      } else {
        console.error("Error fetching details:");
      }
    } catch (err) {
      setError("Failed to fetch details.");
      console.error("Error fetching details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardMetrics();
  }, []);
  if (loading) {
    return <Loader />;
  }
  return (
    <section className="content adminUser dashboard">
      <div className="container-fluid">
        {dasboardData && (
          <div className="cardBox-body">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="cardBox-content">
                  <label>Users</label>
                  <h2>{dasboardData?.totalUsers}</h2>
                  {/* <hr /> */}
                </div>
              </div>
              {/* <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
              <div className="cardBox-content">
                <label>Active user</label>
                <h2>2,300</h2>
              </div>
            </div> */}
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="cardBox-content">
                  <label>Companies Registered</label>
                  <h2>{dasboardData?.totalCompanies}</h2>
                  {/* <hr /> */}
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="cardBox-content">
                  <label> Projects</label>
                  <h2>{dasboardData?.totalProjects}</h2>
                  {/* <hr /> */}
                  {/* <p> Just updated</p> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="cardBox-content">
                  <div className="card-header-top">
                    <h5 className="mb-0">Active Users</h5>
                  </div>

                  {/* Tabs */}
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabUsers  === "1day" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabUsers("1day")}
                      >
                        Last 1 Day
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabUsers  === "7days" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabUsers("7days")}
                      >
                        Last 7 Days
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabUsers  === "30days" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabUsers("30days")}
                      >
                        Last 30 Days
                      </button>
                    </li>
                  </ul>

                  {/* Card Content */}
                  <div className="card-body card-body-content">
                    {activeTabUsers  === "1day" && (
                      <>
                        <h2>{dasboardData?.activeUsers?.last1Day}</h2>
                        <p className="text-muted">in last 1 day</p>
                      </>
                    )}
                    {activeTabUsers  === "7days" && (
                      <>
                        <h2>{dasboardData?.activeUsers?.last7Days}</h2>
                        <p className="text-muted">in last 7 days</p>
                      </>
                    )}
                    {activeTabUsers  === "30days" && (
                      <>
                        <h2>{dasboardData?.activeUsers?.last30Days}</h2>
                        <p className="text-muted">in last 30 days</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                <div className="cardBox-content">
                  <div className="card-header-top">
                    <h5 className="mb-0">Active Projects</h5>
                  </div>

                  {/* Tabs */}
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabProjects  === "1day" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabProjects("1day")}
                      >
                        Last 1 Day
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabProjects  === "7days" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabProjects("7days")}
                      >
                        Last 7 Days
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTabProjects  === "30days" ? "active" : ""
                        }`}
                        onClick={() => setActiveTabProjects("30days")}
                      >
                        Last 30 Days
                      </button>
                    </li>
                  </ul>

                  {/* Card Content */}
                  <div className="card-body card-body-content">
                    {activeTabProjects === "1day" && (
                      <>
                        <h2>{dasboardData?.projectsCreated?.last1Day}</h2>
                        <p className="text-muted">in last 1 day</p>
                      </>
                    )}
                    {activeTabProjects === "7days" && (
                      <>
                        <h2>{dasboardData?.projectsCreated?.last7Days}</h2>
                        <p className="text-muted">in last 7 days</p>
                      </>
                    )}
                    {activeTabProjects === "30days" && (
                      <>
                        <h2>{dasboardData?.projectsCreated?.last30Days}</h2>
                        <p className="text-muted">in last 30 days</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Dashboard;
